// removed by extract-text-webpack-plugin
module.exports = {"container":"wyixfBM-Percb1wZGMhIm","notifications":"S7QZudiaOj5gJGeTzSjFF","unread":"_5cRk-ixLbgaWvXjrIuXCw","logout":"_2sPHWWgid07yj9NwlZ7Arh"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c9837af","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/logged-in-layout/header-top/user-info.less
// module id = 3AeD
// module chunks = 1